import {inject} from '@angular/core';
import {Tracker, trackPageView} from "./tracking";
import {MetaPixelService} from "./meta-pixel.service";
import {AnalyticsService} from "./analytics.service";
import {TrackingEvent} from "./tracking-event";
import {Router} from "@angular/router";
import {ConsentService} from "../services/consent.service";

export abstract class TrackingService {

  abstract track(event: TrackingEvent): void;

}

export class BrowserTrackingService extends TrackingService {

  private readonly trackers: Tracker[] = [
    inject(MetaPixelService),
    inject(AnalyticsService)
  ];

  constructor() {
    super();
    const router = inject(Router);
    const consentService = inject(ConsentService);
    this.trackers.forEach(tracker => trackPageView(
      tracker,
      router,
      consentService.signalFor(tracker.category())
    ));
  }

  track(event: TrackingEvent) {
    console.debug("Tracking custom event: ", event);
    this.trackers.forEach(tracker => tracker.trackCustomEvent(event));
  }

}

export class ServerTrackingService extends TrackingService {
  track(_event: TrackingEvent): void {
  }
}
